import { useNavigate } from "react-router-dom";
import { ParallaxProvider } from "react-scroll-parallax";


const Actualite: React.FC = () => {
  const navigate = useNavigate();
 
  return (
    <ParallaxProvider>
    
      <div className="flex flex-col items-center justify-center h-screen">
        <h1 className="text-4xl font-bold">Page actualité </h1>
      </div>
     
    </ParallaxProvider>
  );
};

export default Actualite;
